<template>
  <div class="text-center" @touchend="onClick" @click="onClick">
    <div class="btn relative">
      <transition-group name="fade" tag="div">
        <!--
          Sanne ships the whole ring as one flat illustration (no gradient
          layers to stack), so it breathes as a single image; the default brand
          keeps its four-layer purple ring.
        -->
        <img
          v-if="isSanne"
          :key="'ring'"
          class="img-ring"
          :class="{ breathing: shouldBreath }"
          v-show="!active"
          :src="sanneRing"
        />
        <template v-else>
          <img
            :key="1"
            class="img-1"
            :class="{ breathing: shouldBreath }"
            v-show="!active"
            src="../../assets/HoverButton/main-1.svg"
          />
          <img
            :key="2"
            class="img-2"
            :class="{ breathing: shouldBreath }"
            v-show="!active"
            src="../../assets/HoverButton/main-2.svg"
          />
          <img :key="3" class="img-3" v-show="!active" src="../../assets/HoverButton/main-3.svg" />
          <img :key="4" class="img-4" v-show="!active" src="../../assets/HoverButton/main-4.svg" />
        </template>
      </transition-group>
      <transition-group name="fill" tag="div">
        <img
          :key="5"
          class="img-5"
          :class="{ 'img-ring': isSanne }"
          v-show="active"
          :src="brandAsset(mainFill, sanneRing)"
        />
      </transition-group>
    </div>
    <div v-if="!active && showHint" class="relative mt-5 md:mt-16">
      <img class="mx-auto mb-2" :src="brandAsset(triangle, sanneCaret)" />
      <p class="instruction text-xl md:text-2xl main-gradient">{{ showHint }}</p>
    </div>
  </div>
</template>

<script>
import breathing from '../../mixins/breathing';
import brandMode from '../../mixins/brand-mode';
import mainFill from '../../assets/HoverButton/main-fill.svg';
import triangle from '../../assets/HoverButton/gradient-triangle.svg';
import sanneRing from '../../assets/sanne/hover-ring.svg';
import sanneCaret from '../../assets/sanne/caret.svg';

export default {
  name: 'HoverButton',
  props: {
    showHint: String,
    hit: Boolean,
    hitDuration: {
      type: Number,
      default: 1200,
    },
  },
  mixins: [breathing, brandMode],
  mounted() {
    this.hitTimer = null;
  },
  beforeDestroy() {
    if (this.hitTimer) {
      clearTimeout(this.hitTimer);
    }
  },
  data: () => ({
    active: false,
    mainFill,
    triangle,
    sanneRing,
    sanneCaret,
  }),
  watch: {
    hit(nv, ov) {
      if (nv && !ov) {
        this.onHit();
      } else if (ov && !nv) {
        this.active = false;
      }
    },
  },
  methods: {
    onHit() {
      if (this.active) return;

      this.active = true;
      this.hitTimer = setTimeout(() => {
        this.$emit('click');
        this.$emit('active');
      }, this.hitDuration);
    },
    onClick() {
      if (this.active) return;

      this.$emit('click');
      this.$emit('active');
      this.active = true;
      setTimeout(() => {
        this.active = false;
      }, this.hitDuration);
    },
  },
};
</script>

<style scoped lang="scss">
.btn {
  @apply mx-auto w-40 h-40;
  @screen md {
    @apply w-56 h-56;
  }
  & > div {
    @apply absolute w-40 h-40 left-0 right-0 flex mx-auto justify-center items-center;
    @screen md {
      @apply w-56 h-56;
      transform: scale(1.5);
    }
    img {
      @apply absolute;
    }
  }
}

.fade-enter-active {
  transition: all 0.5s ease-in;
}
.fade-leave-active {
  transition: all 1.2s ease-out;
}
.fade-enter-to,
.fade-leave {
  transform: scale(1) rotate(0);
}
.fade-enter,
.fade-leave-to {
  transform: scale(0) rotate(-200deg);
  &.img-3 {
    transform: scale(0);
  }
}

.fill-enter-active {
  transition: all 0.5s ease-out;
}
.fill-leave-active {
  transition: all 0.3s ease-out;
}
.fill-enter-to,
.fill-leave {
  transform: scale(1);
}
.fill-enter,
.fill-leave-to {
  transform: scale(0);
}
.img-3 {
  transform: scale(1.1);
}
// The Sanne ring is a 320px illustration; size it to the button box instead
// of letting the img fall back to its intrinsic width.
.img-ring {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.instruction {
  font-family: var(--font-heading);
  font-weight: 500;
  line-height: 1.25;
  color: var(--color-accent);
}
.main-gradient {
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-image: var(--brand-gradient-vertical);
  color: var(--color-accent);
}
</style>
